import ModuleEightReflection from "../../../../src/components/forms/ModuleEightReflection";
import * as React from 'react';
export default {
  ModuleEightReflection,
  React
};